module.exports = __webpack_public_path__ + "static/img/airtimelogo.87b9e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airtimelogo.png
// module id = hQcL
// module chunks = 1